import {styled, Typography} from '@mui/material';

export const Heading = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.pxToRem(40),
  fontFamily: 'Lato',
  fontWeight: '600',
  textAlign: 'center',
  color: theme.palette.common.black,
  maxWidth: theme.typography.pxToRem(250),
  lineHeight: '1.1em',
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('md')]: {
    maxWidth: 'fit-content',
  },
}));
